import React from "react";

const BlogContent = ({ html }) => (
  <div
    className="blog-content max-w-none"
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

export default BlogContent;
